import ShadowWrapper from "components/Common/ShadowWrapper";
import i18n from "src/i18n";

const PrivacyPolicy2026ToNow = () => {
  const htmlContent = `
<!DOCTYPE html>
<html lang="ko">
  <head>
    <meta charset="UTF-8" />
    <title>주식회사 파수에이아이 클라우드 서비스 통합 개인정보 처리방침</title>
    <style>
      html, body, div, span, object, iframe, h1, h2, h3, h4, h5, h6, blockquote, pre, abbr, address, cite, code, del, dfn, em, img, ins, kbd, q, samp, small, strong, sub, sup, var, b, i, a, dl, dt, dd, fieldset, form, label, legend, table, caption, tbody, tfoot, thead, tr, th, td, article, aside, canvas, details, figcaption, figure, footer, header, hgroup, menu, nav, section, summary, time, mark, audio, video {
        margin: 0;
        padding: 0;
        border: 0;
        outline: 0;
        text-decoration: none;
      }
      table {
        border-collapse: collapse;
        width: 100%;
      }
      body {
        font-family: "Noto Sans KR", Sans-serif;
      }
      h1 {
        font-size: 24px;
        text-align: center;
        padding: 20px 0;
      }
      .data-tb {
        width: 90%;
        margin: 20px auto;
      }
      .data-tb table, .data-tb th, .data-tb td {
        border: 1px solid #ececec;
        font-size: 14px;
      }
      .data-tb th {
        padding: 10px;
        background-color: rgba(185, 185, 185, 0.08);
      }
      .data-tb td {
        padding: 12px 20px;
        font-size: 12px;
        vertical-align: top;
      }
      .data-tb table th.color {
        font-weight: bold;
        background-color: rgba(61, 219, 135, 0.08);
      }
      .data-tb table th.color-yellow {
        font-weight: bold;
        background-color: rgba(242, 255, 125, 0.08);
      }
      ul {
        list-style-type: none;
      }
      ul, ol {
        padding-inline-start: 20px;
      }
      li {
        color: #797b82;
        margin-top: 10px;
        font-size: 14px;
      }
      .title {
        margin-top: 50px;
        margin-bottom: 13px;
        font-size: 22px;
        color: #28292b;
      }
      .contents {
        margin-top: 10px;
        font-size: 14px;
        color: #797b82;
        line-height: 150%;
      }
    </style>
  </head>
  <body>
    <h1>주식회사 파수에이아이 클라우드 서비스 통합 개인정보 처리방침</h1>
    <p class="contents">주식회사 파수에이아이(이하 '회사'라 합니다)는 회사가 운영하는 클라우드포탈(cloudportal.fasoo.com) 및 이를 통해 제공되는 개별 클라우드 서비스(Wrapsody, Wrapsody eCo, Mind-SAT, Fireside, Fasoo DSP, Fasoo DSPM 등, 이하 '서비스') 이용자의 개인정보를 안전하게 보호하기 위해 「개인정보 보호법」을 준수하며, 다음과 같이 개인정보 처리방침을 수립하여 공개합니다.</p>
    <p class="contents">본 처리방침은 클라우드포탈 첫 화면 하단 및 서비스 '회원가입' 영역 등을 통해 언제든지 쉽게 확인하실 수 있습니다.</p>

    <h3 class="title">1. 개인정보의 수집 항목 및 이용 목적</h3>
    <p class="contents">회사는 클라우드포탈 및 서비스 사이트를 통한 회원가입 및 결제 시 개인정보를 수집하며, 이를 기반으로 신청하신 개별 서비스의 계정(ID/PW)을 생성하여 서비스를 제공합니다. 회사가 수집하는 모든 개인정보는 '계약의 체결 및 이행'을 위한 필수 정보로서, 아래 법령에 따라 수집·처리합니다.</p>
    <ul>
      <li>계약 이행 목적 (개인정보 보호법 제15조 제1항 제4호): 회원 가입·계정 발급·결제 정산·고객 상담 등 서비스 계약의 체결 및 이행에 필요한 개인정보</li>
      <li>정당한 이익 목적 (개인정보 보호법 제15조 제1항 제6호): 서비스 안정성 확보를 위한 주요 공지사항 전달, 신규 서비스 개발 및 이용 통계 분석 등 회사의 정당한 이익을 위해 처리되는 개인정보 (정보주체의 이익을 침해하지 않는 범위 내)</li>
      <li>수집 및 이용 목적:
        <ul>
          <li>클라우드포탈 회원 가입 및 클라우드 서비스 제공 계약 이행</li>
          <li>신청한 개별 서비스(Mind-SAT, Wrapsody 등)의 사용자 계정 발급 및 연동 처리</li>
          <li>사내 고객 관리 시스템을 활용한 회원 관리, 서비스 요금 결제, 정산 및 청구서 발송</li>
          <li>고객 상담 및 민원 처리 (사내 통합 고객지원 솔루션 'Fireside' 연동을 통한 실시간 채팅 상담 등)</li>
          <li>서비스 안정성 확보 및 이용자 보호를 위한 주요 공지사항(보안 패치, 시스템 업데이트, 약관 변경 등) 전달</li>
          <li>신규 서비스 개발, 서비스 유효성 확인, 접속 빈도 파악 및 회원의 서비스 이용에 대한 통계 분석 (※ 마케팅 및 광고 활용 목적 아님)</li>
        </ul>
      </li>
      <li>수집 항목: ID, 비밀번호, 성명, 소속 회사명, 부서명, 직급, 회사 이메일 주소, 휴대전화 번호, 유료 결제 시 결제 정보(신용카드 정보 등), 서비스 이용 기록(로그), 접속 IP, 쿠키</li>
      <li>수집 방법: 클라우드포탈 및 서비스 내 회원가입 및 결제 과정, 고객센터 및 서비스 내 챗 문의</li>
    </ul>
    <p class="contents">※ 회사는 정보주체의 명시적인 동의가 필요한 마케팅 및 맞춤형 광고 목적의 개인정보는 수집하지 않습니다.</p>

    <h3 class="title">2. 외부 API 데이터 활용 및 인공지능(AI) 학습 제한</h3>
    <p class="contents">회사는 이용자의 데이터를 보호하고 대외 서비스 정책을 준수하기 위해 외부 API와 연동된 데이터에 대해 다음과 같은 정책을 유지합니다.</p>
    <ul>
      <li>API 데이터 활용 범위: 회사는 Google Workspace API 등 외부 API를 통해 수집하거나 접근 권한을 획득한 사용자 데이터를 서비스의 본래 기능 제공 및 기술 지원 목적 외에 다른 용도로 활용하지 않습니다.</li>
      <li>AI/ML 모델 학습 금지: 회사는 외부 API를 통해 수집한 사용자 데이터를 일반화된 인공지능(AI) 및 머신러닝(ML) 모델의 개발, 개선 또는 훈련 목적으로 사용하지 않습니다.</li>
      <li>데이터의 독립성: 이용자의 데이터는 오직 해당 이용자의 서비스 환경 내에서만 처리되며, 회사의 다른 서비스나 범용적인 AI 알고리즘을 고도화하기 위한 기초 자료로 활용되지 않음을 보장합니다.</li>
    </ul>

    <h3 class="title">3. 개인정보의 보유 및 이용기간</h3>
    <p class="contents">원칙적으로 회원의 클라우드포탈 탈퇴 등 계약이 종료되어 수집 및 이용 목적이 달성된 후에는 포탈 및 개별 서비스에 등록된 해당 개인정보를 지체 없이 일괄 파기합니다. 단, 관계 법령에 의하여 보존할 필요가 있는 경우 아래의 기준에 따라 보관합니다.</p>
    <ul>
      <li>관련 법령에 의한 정보 보유 사유
        <ul>
          <li>대금결제 및 재화 등의 공급에 관한 기록 (전자상거래법): 5년</li>
          <li>계약 또는 청약철회 등에 관한 기록 (전자상거래법): 5년</li>
          <li>소비자의 불만 또는 분쟁처리에 관한 기록 (전자상거래법): 3년</li>
          <li>웹사이트 방문 및 서비스 접속 기록 (통신비밀보호법): 3개월</li>
        </ul>
      </li>
    </ul>

    <h3 class="title">4. 개인정보 처리의 위탁</h3>
    <p class="contents">회사는 원활한 통합 포탈 운영, 개별 서비스 인프라 관리 및 결제 처리를 위하여 아래와 같이 필수적인 개인정보 처리 업무를 외부 전문업체에 위탁하고 있습니다.</p>
    <ul>
      <li>Amazon Web Services (AWS): 클라우드 서비스 제공을 위한 인프라(서버) 운영 및 데이터 보관(서비스 지역에 따라 국내 또는 국외 리전 활용)</li>
      <li>Oracle: 클라우드 서비스 제공을 위한 인프라(서버) 운영 및 데이터 보관</li>
      <li>KG이니시스: 국내 신용카드 결제 대행 및 에스크로 서비스</li>
      <li>Paypal: 국외 신용카드 및 계정 결제 대행 서비스</li>
      <li>(주)알리는사람들 (알리고): 서비스 안정성 확보 및 주요 안내 사항에 대한 문자 메시지(SMS/LMS) 발송</li>
    </ul>
    <p class="contents">※ 위탁 및 보유 기간: 회원 탈퇴 시 또는 위탁 계약 종료 시까지 (단, 관련 법령에 따라 보존 의무가 있는 경우 해당 기간까지)</p>

    <h3 class="title">5. 개인정보의 제3자 제공</h3>
    <p class="contents">회사는 원칙적으로 이용자의 개인정보를 제3자에게 제공하지 않습니다. 다만, 다음 각 호의 경우에는 예외로 합니다.</p>
    <ul>
      <li>이용자가 사전에 동의한 경우</li>
      <li>법령의 규정에 의하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우</li>
    </ul>
    <p class="contents">위의 각 호를 제외하고는 이용자의 개인정보를 제3자에게 제공하고 있지 않습니다.</p>

    <h3 class="title">6. 개인정보의 국외 이전</h3>
    <p class="contents">회사는 글로벌 클라우드 인프라 운영 및 해외 결제 처리를 위하여 아래와 같이 개인정보를 국외로 이전(위탁 및 보관)하고 있습니다. 본 항목은 해외 리전(미국 등) 기반 서비스를 이용하거나 글로벌 결제를 진행하는 경우에 한하여 적용됩니다. 이용자는 고객센터 및 개인정보 보호책임자를 통해 국외 이전을 거부할 수 있으나, 이 경우 서비스 이용 및 글로벌 결제 서비스 사용이 제한될 수 있습니다.</p>
    <p class="contents" style="margin-top: 15px; font-weight: bold;">Amazon Web Services Inc. (미국 리전)</p>
    <ul>
      <li>이전 항목: 서비스 이용 과정에서 생성·수집된 모든 개인정보 및 데이터(미국 리전 이용 시)</li>
      <li>이전 일시 및 방법: 서비스 이용 시점에 네트워크를 통해 수시 전송 및 보관</li>
      <li>이전 목적 및 보유기간: 클라우드 인프라 제공 및 데이터 보관 / 회원 탈퇴 또는 서비스 종료 시까지</li>
      <li>이전 받는 자: Amazon Web Services, Inc. (https://aws.amazon.com/compliance/contact/)</li>
    </ul>
    <p class="contents" style="margin-top: 15px; font-weight: bold;">Paypal Inc. (미국 등)</p>
    <ul>
      <li>이전 항목: 이메일 주소, 결제 금액, 신용카드/계정 정보 등 결제 승인 정보</li>
      <li>이전 일시 및 방법: 결제 승인 시점에 네트워크를 통해 실시간 전송</li>
      <li>이전 목적 및 보유기간: 글로벌 유료 결제 처리 및 부정 거래 방지 / 결제 완료 및 관련 법령에 따른 보존 기간까지</li>
      <li>이전 받는 자: PayPal, Inc. (https://www.paypal.com/us/cshelp/contact-us)</li>
    </ul>
    <p class="contents" style="margin-top: 15px; font-weight: bold;">Oracle Corporation (미국)</p>
    <ul>
      <li>이전 항목: 서비스 이용 과정에서 생성·수집된 모든 개인정보 및 데이터 (Oracle 클라우드 리전 이용 시)</li>
      <li>이전 일시 및 방법: 서비스 이용 시점에 네트워크를 통해 수시 전송 및 보관</li>
      <li>이전 목적 및 보유기간: 클라우드 인프라 제공 및 데이터 보관 / 회원 탈퇴 또는 서비스 종료 시까지</li>
      <li>이전 받는 자: Oracle Corporation (https://www.oracle.com/legal/privacy/)</li>
    </ul>
    <p class="contents">※ 회사는 국외 이전 시 개인정보 보호법 제28조의8에 따라 이전 받는 자가 개인정보를 안전하게 처리하도록 필요한 조치를 취하고 있습니다.</p>

    <h3 class="title">7. 정보주체의 권리·의무 및 그 행사 방법</h3>
    <p class="contents">이용자는 개인정보주체로서 언제든지 다음과 같은 권리를 행사할 수 있습니다.</p>
    <ul>
      <li>1. 개인정보 열람, 정정, 삭제 및 처리정지 요구: 클라우드포탈 내 '내 정보 관리'를 통해 계정 정보를 직접 정정·삭제(탈퇴)할 수 있으며, 탈퇴 시 연동된 개별 서비스(Mind-SAT 등)의 정보도 함께 파기됩니다.</li>
      <li>2. 개인정보 전송요구권: 정보주체는 본인의 개인정보를 본인 또는 제3자에게 전송해 줄 것을 요구할 수 있습니다. 전송 요구는 고객센터 이메일을 통해 접수 가능하며, 회사는 확인 후 안전한 방식으로 데이터를 전송합니다.</li>
      <li>3. 자동화된 결정에 대한 설명 요구 및 거부권: 완전히 자동화된 시스템으로 처리되는 결정이 정보주체의 권리에 중대한 영향을 미치는 경우, 이에 대한 설명을 요구하거나 결정을 거부할 수 있습니다.</li>
    </ul>
    <p class="contents">위 권리는 귀하의 법정대리인이나 위임을 받은 자도 행사할 수 있으며, 이 경우 위임장 및 대리인 신분증 사본을 제출하셔야 합니다. 권리 행사는 고객센터 이메일 또는 개인정보 보호책임자에게 서면·이메일로 요청하실 수 있습니다.</p>

    <h3 class="title">8. 개인정보 자동 수집 장치의 설치·운영 및 거부에 관한 사항</h3>
    <p class="contents">회사는 통합 클라우드포탈 및 개별 서비스 이용 시 안전한 클라우드 환경을 제공하고 안전한 로그인 상태 유지 등을 위해 이용자의 정보를 수시로 저장하고 불러오는 '쿠키(Cookie)' 등을 사용합니다.</p>
    <ul>
      <li>쿠키의 사용 목적: 이용자의 웹 브라우저에 식별자(세션 ID)를 임시로 저장하여, 개별 서비스 간 화면 연동(iframe 등) 시 안전한 개별 로그인 상태를 유지하고 원활한 결제 처리를 돕는 필수적인 용도(세션 쿠키)로만 사용됩니다.</li>
      <li>서비스 이용 기록의 활용 및 제한: 회사는 서비스의 기능 개선 및 서버 부하 분산 등을 목적으로 접속 빈도, 서비스 이용 로그 등 최소한의 이용 패턴 정보를 분석할 수 있습니다. 해당 정보는 특정 개인을 식별하거나 성향을 분석하여 맞춤형 광고를 제공하는 등의 마케팅 목적(타겟 마케팅 등)으로는 절대 활용되지 않습니다.</li>
      <li>쿠키의 설치·운영 및 거부: 이용자는 웹 브라우저 옵션 설정을 통해 쿠키 저장을 거부할 수 있습니다. 단, 필수 세션 유지를 위한 쿠키 저장을 거부할 경우 로그인이 필요한 서비스 이용 및 결제 처리가 불가능합니다.
        <ul>
          <li>Chrome (PC/모바일): 우측 상단 메뉴 [설정] &gt; [개인정보 및 보안] &gt; [서드 파티 쿠키]에서 차단 설정 또는 '새 시크릿 창' 활용</li>
          <li>Edge 브라우저: [설정] &gt; [쿠키 및 사이트 권한] &gt; [쿠키 및 사이트 데이터 관리 및 삭제]</li>
        </ul>
      </li>
    </ul>

    <h3 class="title">9. 개인정보의 안전성 확보 조치</h3>
    <p class="contents">회사는 이용자의 개인정보를 취급함에 있어 분실, 도난, 유출, 변조 또는 훼손되지 않도록 다음과 같은 안전성 확보 조치를 취하고 있습니다.</p>
    <ul>
      <li>1. 관리적 조치: 내부관리계획 수립 및 시행, 전 임직원 대상 정기적 개인정보 보호 교육 실시, 임직원의 보안 의식 고취 및 대응력 강화를 위한 정기적인 악성 메일 모의 훈련 실시 등</li>
      <li>2. 기술적 조치: 개인정보처리시스템 등의 접근권한 관리 및 인증(2단계 인증), 비밀번호 및 주요 데이터의 암호화 저장, 전송 시 보안구간(SSL) 적용, 최신 백신 및 보안프로그램 설치 등</li>
      <li>3. 물리적 조치: 전산실 등의 출입통제 및 잠금장치 사용</li>
    </ul>

    <h3 class="title">10. 개인정보 보호책임자 및 실무 고충처리 부서</h3>
    <p class="contents">회사는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 이와 관련한 정보주체의 불만 처리 및 피해구제를 위하여 아래와 같이 담당자를 지정하고 있습니다.</p>
    <ul>
      <li>개인정보 보호책임자 (CPO)
        <ul>
          <li>성명/직책: 김용길 상무</li>
          <li>연락처: 02-300-9120, kimyg@fasoo.com</li>
        </ul>
      </li>
      <li>개인정보 보호담당자
        <ul>
          <li>성명/직책: 박현수 수석</li>
          <li>연락처: 02-300-9093, hspark@fasoo.com</li>
        </ul>
      </li>
      <li>클라우드서비스 담당 부서
        <ul>
          <li>담당 부서명: 클라우드서비스팀</li>
          <li>연락처: 02-300-9000, cloudservice@fasoo.com</li>
        </ul>
      </li>
    </ul>

    <h3 class="title">11. 개인정보 처리방침의 변경</h3>
    <p class="contents">본 개인정보 처리방침은 시행일(2026년 6월 1일)로부터 적용되며, 법령 및 방침에 따른 변경내용의 추가, 삭제 및 정정이 있는 경우에는 아래의 기준에 따라 사전 고지합니다.</p>
    <ul>
      <li>일반 변경 (시행 최소 7일 전 고지): 단순 오류 수정, 연락처 변경, 법령 개정에 따른 자동 반영 등 정보주체의 권리에 실질적 영향이 없는 경우</li>
      <li>중요 변경 (시행 최소 30일 전 고지): 수집 항목 추가·확대, 이용 목적 변경, 제3자 제공 범위 확대, 국외 이전 신설 등 정보주체의 권리에 중대한 영향을 미치는 경우. 이 경우 이메일 등 직접 통지 방법을 병행합니다.</li>
    </ul>
    <p class="contents">고지는 클라우드포탈 공지 및 관리자 대상 이메일 발송을 통해 이루어집니다.</p>

    <h3 class="title">12. 정보주체의 권익구제 방법</h3>
    <p class="contents">이용자는 아래의 기관에 개인정보 침해에 대한 피해구제, 상담 등을 문의하실 수 있습니다. (아래 기관은 회사와는 별개의 기관입니다.)</p>
    <ul>
      <li>개인정보침해 신고센터: (국번없이) 118 / privacy.kisa.or.kr</li>
      <li>개인정보 분쟁조정위원회: (국번없이) 1833-6972 / www.koprc.go.kr</li>
      <li>대검찰청 사이버수사과: (국번없이) 1301 / www.spo.go.kr</li>
      <li>경찰청 사이버수사국: (국번없이) 182 / ecrm.cyber.go.kr</li>
    </ul>
  </body>
</html>`;
  return (
    <div style={{ fontFamily: "Noto Sans KR" }}>
      <ShadowWrapper htmlContent={htmlContent} />
    </div>
  );
};

export default PrivacyPolicy2026ToNow;